// @UI
import { useLightMode } from '@/hooks/useLightMode'

import {
  Box,
  HStack,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
} from '@chakra-ui/react'

export const formatTime = (seconds: number): string => {
  if (isNaN(seconds) || !isFinite(seconds) || seconds < 0) return '0:00'
  const mins = Math.floor(seconds / 60)
  const secs = Math.floor(seconds % 60)
  return `${mins}:${secs.toString().padStart(2, '0')}`
}

interface IProps {
  onSeek: (newValue: number) => void
  played: number
  currentTime: number
  duration: number
}

export const SeekRow = ({ onSeek, played, currentTime, duration }: IProps) => {
  const mode = useLightMode()
  return (
    <HStack align='center' spacing='12px'>
      <Box flex={1}>
        <Slider onChange={onSeek} value={played * 100}>
          <SliderTrack bg='rgba(255,255,255,0.15)' borderRadius='8px' h='8px'>
            <SliderFilledTrack bg={`text.on-accent.${mode}`} />
          </SliderTrack>
          <SliderThumb boxSize='14px' />
        </Slider>
      </Box>
      {duration > 0 && (
        <Box
          color={`text.on-accent.${mode}`}
          flexShrink={0}
          fontSize='11px'
          opacity={0.8}
        >
          {formatTime(currentTime)} / {formatTime(duration)}
        </Box>
      )}
    </HStack>
  )
}
